import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {IThemeCustomizer} from "./theme.service.interface";

export class StandardThemeCustomizer implements IThemeCustomizer {
    constructor(protected readonly services: IServiceFactoryExtended) {}
    getHomePageTopBannerHeight(): string {
        if (this.services.homepage.headerArenasStyleIsSmallTiles) {
            if (this.services.mediaQuery.sAndBelow) {
                return "22rem";
            }

            return "29rem";
        }

        if (this.services.mediaQuery.sAndBelow) {
            return "25rem";
        } else if (this.services.mediaQuery.lAndBelow) {
            return "30rem";
        }

        return "47rem";
    }
}
